<div *ngIf="!loading" [ngClass]="{ container: !urlToken }">
  <!-- NOT AUTHORIZED -->
  <div class="row" *ngIf="!authorized && !urlToken">
    <div class="col-12">
      <pv-email-auth-shopify [order]="order" (success)="authorized = true"></pv-email-auth-shopify>
    </div>
  </div>

  <!-- AUTHORIZED -->
  <div *ngIf="order && (authorized || urlToken)">

    <!-- ORDER DATE AND NUMBER -->
    <div class="row">
      <div class="col-12 order-header">
        <div>Order Number: <span class="bold">{{ order.id }}</span></div>
      </div>
    </div>

    <!-- DOWNLOAD/ACCOUNT BUTTONS -->
    <div class="row row-buttons" >
      <div [routerLink]="['/profile', 'order', order.url_token, 'download']" class="col-sm-4 offset-sm-1" *ngIf="!isWholesale">
        <div class="pv-button">Get Downloads</div>
      </div>
    </div>

  </div>
</div>